function extractFormErrors(errorData) {
    var errors = {};
    Object.values(errorData.violations).forEach(function (errorMessage) {
        var propertyPath = errorMessage.propertyPath;
        // Replace empty string with @general
        if (propertyPath.length === 0) {
            propertyPath = '@general';
        }
        // Only set the first error, the second and other errors should be returned when the first one was solved
        errors[propertyPath] = errorMessage.message;
    });
    return errors;
}
/* eslint-disable import/prefer-default-export */
/**
 *
 * @param {string | Object} error Error response object returned from api
 * @param {Function} setFormErrors State setter function of form errors object
 */
export function handleApiError(error, setFormErrors) {
    var errorResponse = error.response;
    // If there is no response on the error, this is a non-api error, so throw it
    if (!errorResponse) {
        throw Error(error);
    }
    var status = errorResponse.status;
    if (status === 422) {
        var errorData = errorResponse.data;
        setFormErrors(extractFormErrors(errorData));
        return;
    }
    if (status >= 400) {
        setFormErrors({
            '@general': 'Er is iets misgegaan, probeer het nogmaals.',
        });
    }
}
